_ = require 'underscore'
pluginValidators = require 'lib/util/plugin-validators'
sandboxParams = require 'data/plugin-iframe-sandbox'
t = require('views/internal/teacup-with-helpers')('plugin_chrome')

# based on https://stackoverflow.com/a/3943023
useLightText = (color) ->
  [cR, cG, cB] = color.match(/[0-9a-f]{2}/ig).map (hex) ->
    component = parseInt(hex, 16) / 255
    if component <= 0.03928
      component / 12.92
    else
      ((component + 0.055) / 1.055) ** 2.4

  luminance = 0.2126 * cR + 0.7152 * cG + 0.0722 * cB
  luminance <= 0.4623475

renderAction = (action) ->
  target = if pluginValidators.isValidUrlForIframe(action.url) then action.url else '#'
  anchorProps =
    'data-index': action.index
    href: target
    rel: 'noreferrer nofollow noopener'
    target: target
    title: action.alt
  t.a '.plugin-chrome-header-action', anchorProps, ->
    t.span '.plugin-action-icon', { style: "background-image: url('#{ action.icon }');" }

module.exports = t.renderable (content) ->
  { url, height, context, accentColor, title, actions, fullscreen } = content
  if content.type != 'iframe'
    return
  if !accentColor? || !/^#[a-fA-F0-9]{6}$/.test(accentColor)
    accentColor = '#EDEFF0'

  validActions = _.chain(actions)
    .filter((a) -> pluginValidators.isValidUrlForImage(a.icon))
    .map((a) -> _.extend a, { index: actions.indexOf(a) })
    .groupBy('position')
    .value()

  leftActions = validActions.left?.slice(0, 3) || []
  rightActions = validActions.right?.slice(0, 1) || []

  if rightActions.length == 1
    leftActions = leftActions.slice(0, 2)

  t.div '.plugin-chrome-header', { style: "background-color: #{ accentColor };" }, ->
    t.div '.plugin-chrome-header-left-actions', ->
      leftActions.map renderAction
    t.span '.plugin-chrome-title', { class: t.classify('light': useLightText(accentColor)) }, ->
      t.text title
    t.div '.plugin-chrome-header-right-actions', ->
      rightActions.map renderAction
      t.a '.plugin-chrome-close-button.icon-lg.icon-close.js-close-plugin-chrome',
        class: t.classify('light': useLightText(accentColor))
        href: '#'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/plugin_chrome_header.coffee